/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Comandero — Compras (LÓGICA PURA)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * CC-6: archivo `.ts` PURO. Sin macros lingui ni UI. Montos en centavos.
 */

export interface PurchaseLine {
  /** Unidades de stock que entran (entero ≥ 0). */
  qty: number;
  /** Costo por unidad, en centavos. */
  unitCost: number;
}

/** Total de una línea de compra = qty × unitCost (centavos). */
export function purchaseLineTotal(line: PurchaseLine): number {
  return Math.max(0, Math.trunc(line.qty)) * Math.max(0, Math.trunc(line.unitCost));
}

/** Total de una orden de compra = Σ líneas (centavos). */
export function purchaseOrderTotal(lines: PurchaseLine[]): number {
  return lines.reduce((acc, l) => acc + purchaseLineTotal(l), 0);
}
